import { render, staticRenderFns } from "./NodeDetailsView.vue?vue&type=template&id=283fbd10&"
import script from "./NodeDetailsView.vue?vue&type=script&lang=ts&"
export * from "./NodeDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./NodeDetailsView.vue?vue&type=style&index=0&id=283fbd10&prod&lang=scss&"
import style1 from "./NodeDetailsView.vue?vue&type=style&index=1&id=283fbd10&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports